import {getCookieValue, saveCookie} from "common/src/cookies/CookiesHelper";
import {parseConfigString} from"common/src/config-parser";


export const clientIdReducer = (state = getClientId()) => {return state};

function getClientId() {
    let clientPrefix = parseConfigString('CLIENT_PREFIX', '')
    let clientId = getCookieValue(clientPrefix + "ClientId");
    if (clientId !== "undefined" && clientId !== undefined) return clientId;
    clientId = generateClientId();
    saveCookie(clientPrefix + "ClientId", clientId);
    return clientId;
}

const generateClientId = () => Math.floor(Math.random() * 100000000000000);